import { render, staticRenderFns } from "./tab_bar_new.vue?vue&type=template&id=68957211&scoped=true"
import script from "./tab_bar_new.vue?vue&type=script&lang=js"
export * from "./tab_bar_new.vue?vue&type=script&lang=js"
import style0 from "./tab_bar_new.vue?vue&type=style&index=0&id=68957211&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68957211",
  null
  
)

export default component.exports